import React from "react";
import PropTypes from "prop-types";
import VariantProfile from "../variants/VariantProfile";

import { buildVariantThemeStylesheet } from "./VariantThemeStyleResolver";

const VariantTheme = (props) => {
  const website = props.website;
  let cta = props.cta;
  let variant = props.variant;
  const stylesheet = buildVariantThemeStylesheet(
    props.builder,
    props.device,
    cta,
    variant
  );

  // add all theme fonts to data-font attribute (for loading)
  let fonts = [];
  [
    "h1-font-family",
    "h1-font-family-mobile",
    "h2-font-family",
    "h2-font-family-mobile",
    "h3-font-family",
    "h3-font-family-mobile",
    "h4-font-family",
    "h4-font-family-mobile",
    "h5-font-family",
    "h5-font-family-mobile",
    "h6-font-family",
    "h6-font-family-mobile",
    "p-font-family",
    "p-font-family-mobile",
    "button-font",
    "field-font",
    "field-label-font-family",
    "timer-number-font",
    "list-content-font-family",
    "timer-message-font",
    "progress-text-font",
    "quiz-progress-text-font",
    "products-item-title-font",
    "products-item-price-font",
    "products-item-description-font",
    "quiz-option-font-family",
    "quiz-button-font",
    "products-reviews-font-family",
    "products-variant-picker-font-family",
    "products-quantity-picker-font-family",
    "products-subscription-choices-font-family",
    "products-image-badge-font-family",
    "products-add-all-btn-font-family",
    "products-remove-from-cart-font-family",
    "reviews-title-font-family",
    "reviews-content-font-family",
    "reviews-customer-profile-name-font-family",
    "reviews-customer-profile-title-font-family",
    "reviews-date-font-family",
    "reviews-source-font-family",
  ].forEach((optionName) => {
    let value = variant.options[optionName];

    if (value && fonts.includes(value) == false) {
      fonts.push(value);
    }
  });

  return (
    <React.Fragment>
      {website && website.data && (
        <React.Fragment>
          {website.data["site-heading-font-family"] &&
            website.data["site-heading-font-url"] && (
              <React.Fragment>
                {(cta.cta_type == "page" ||
                  variant.options["load-custom-fonts"] == "true" ||
                  props.builder) && (
                  <link
                    rel="stylesheet"
                    href={website.data["site-heading-font-url"]}
                  />
                )}
                <style
                  dangerouslySetInnerHTML={{
                    __html: `
                #cta_${cta.id} .cf-element h1,
                #cta_${cta.id} .cf-element h2,
                #cta_${cta.id} .cf-element h3,
                #cta_${cta.id} .cf-element h4,
                #cta_${cta.id} .cf-element h5,
                #cta_${cta.id} .cf-element h6 {
                  font-family: '${website.data["site-heading-font-family"]}', sans-serif;
                }`,
                  }}
                />
              </React.Fragment>
            )}
          {(cta.cta_type == "page" ||
            variant.options["load-custom-fonts"] == "true" ||
            props.builder) &&
            website.data["site-paragraph-font-family"] &&
            website.data["site-paragraph-font-url"] && (
              <React.Fragment>
                {website.data["site-paragraph-font-url"] !==
                  website.data["site-heading-font-url"] && (
                  <link
                    rel="stylesheet"
                    href={website.data["site-paragraph-font-url"]}
                  />
                )}
                <style
                  dangerouslySetInnerHTML={{
                    __html: `
                #cta_${cta.id} .cf-element,
                #cta_${cta.id} .cf-element div,
                #cta_${cta.id} .cf-element p:not(.empty-container),
                #cta_${cta.id} .cf-element span:not(.select-label-span),
                #cta_${cta.id} .cf-element button,
                #cta_${cta.id} .cf-element input,
                #cta_${cta.id} .cf-element select,
                #cta_${cta.id} .cf-element label {
                  font-family: '${website.data["site-paragraph-font-family"]}', sans-serif;
                }`,
                  }}
                />
              </React.Fragment>
            )}
        </React.Fragment>
      )}
      {/* Stays an inline tag on purpose: theme fallbacks (no !important) rely
          on rendering after the campaign base CSS (cta/_css.html.erb) in
          document order — a consolidated head bucket would lose those ties. */}
      <style
        data-font={fonts.join(", ")}
        dangerouslySetInnerHTML={{ __html: stylesheet }}
      />
    </React.Fragment>
  );
};

export default VariantTheme;
